import React, { useRef, useState } from "react";

import styled from "styled-components";

import { db } from "../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { getLogin, infoAction } from "../slices/LoginInfoSlice";

const LoginPage = () => {
  const { assign } = useSelector(state => state.LoginInfoSlice);
  const dispatch = useDispatch();
  const setAssign = value => {
    dispatch(infoAction({ target: "assign", value }));
  };

  const [error, setError] = useState(false);
  const [checkId, setCheckId] = useState(null);
  const [checkNick, setCheckNick] = useState(null);
  const idRef = useRef();
  const pwRef = useRef();
  const nicknameRef = useRef();
  const LoginHandler = async () => {
    const id = idRef.current.value;
    if (id) {
      const docRef = doc(db, "users", id);
      const idDoc = await getDoc(docRef);
      if (idDoc.exists()) {
        const { id, password, nickname } = idDoc.data();
        if (password === pwRef.current.value) {
          dispatch(getLogin({ userId: id, nickname }));
          localStorage.setItem("id", id);
          localStorage.setItem("nickname", nickname);
        } else {
          setError({ errorStatus: true, errorText: "비밀번호가 틀렸습니다." });
        }
      } else {
        setError({ errorStatus: true, errorText: "계정이 존재하지 않습니다." });
      }
    } else {
      setError({ errorStatus: true, errorText: "정보를 확인해주세요." });
    }
  };
  const AssignHandler = async () => {
    if (checkId && checkNick) {
      const id = idRef.current.value;
      const password = pwRef.current.value;
      const nickname = nicknameRef.current.value;

      if (id && password && nickname) {
        const docRef = doc(db, "users", id);
        const idDoc = await getDoc(docRef);
        if (idDoc.exists()) {
          toast.error("이미 존재하는 계정입니다.");
        } else {
          await setDoc(docRef, {
            id,
            password,
            nickname,
          });
          dispatch(getLogin({ userId: id, nickname }));
          localStorage.setItem("id", id);
          localStorage.setItem("nickname", nickname);
        }
      } else {
        toast.error("값을 확인 해주세요");
      }
    } else {
      toast.error("중복 확인을 해주세요");
    }
  };

  const CheckDb = async (key, string, setState) => {
    const usersCollection = collection(db, "users");

    const q = query(usersCollection, where(key, "==", string));

    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      setState(false);
    } else {
      setState(true);
    }
  };

  return (
    <Wrap>
      <Title>계정</Title>
      <SubTitle>LOGIN</SubTitle>
      <InputContainer>
        <InputWrap>
          <CheckTextItem $check={checkId}>
            <span>아이디:</span>
            {checkId !== null && (
              <span>
                {checkId
                  ? "사용 가능한 아이디 입니다."
                  : "중복된 아이디 입니다."}
              </span>
            )}
          </CheckTextItem>
          <InputItem>
            <CustomInput
              $check={checkId}
              onChange={() => {
                if (checkId !== null) {
                  setCheckId(null);
                }
              }}
              $assign={assign}
              ref={idRef}
              placeholder="ID"
            />
            {assign && (
              <CheckButton
                onClick={() => CheckDb("id", idRef.current.value, setCheckId)}>
                중복 체크
              </CheckButton>
            )}
          </InputItem>
        </InputWrap>

        <InputWrap>
          <span>비밀번호:</span>
          <CustomInput
            $assign={assign}
            ref={pwRef}
            type="password"
            placeholder="PW"
          />
        </InputWrap>

        {assign && (
          <InputWrap>
            <CheckTextItem $check={checkNick}>
              <span>닉네임:</span>
              {checkNick !== null && (
                <span>
                  {checkNick
                    ? "사용 가능한 닉네임 입니다."
                    : "중복된 닉네임 입니다."}
                </span>
              )}
            </CheckTextItem>
            <InputItem>
              <CustomInput
                $check={checkNick}
                $assign={assign}
                ref={nicknameRef}
                placeholder="NICKNAME(최대 5글자)"
                maxLength={5}
                onChange={() => {
                  if (checkNick !== null) {
                    setCheckNick(null);
                  }
                }}
              />
              {assign && (
                <CheckButton
                  onClick={() =>
                    CheckDb("nickname", nicknameRef.current.value, setCheckNick)
                  }>
                  중복 체크
                </CheckButton>
              )}
            </InputItem>
            <NicknameComment>*6자까지 사용 가능합니다.</NicknameComment>
          </InputWrap>
        )}
      </InputContainer>
      {!assign && (
        <AssignSpan onClick={() => setAssign(!assign)}>회원 가입</AssignSpan>
      )}
      <LoginButton onClick={assign ? AssignHandler : LoginHandler}>
        {assign ? "가입" : "로그인"}
      </LoginButton>
      {error && (
        <ErrorText>
          {error.errorText ||
            "가입된 회원이 아니거나 비밀번호가 틀립니다. \n로그인 정보를 다시 확인해주세요."}
        </ErrorText>
      )}
    </Wrap>
  );
};

export default LoginPage;

const Title = styled.div`
  font-weight: 700;
  font-size: 19px;
`;
const SubTitle = styled.div`
  font-size: 16px;
  margin-top: 28px;
  margin-bottom: 16px;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CheckTextItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  :nth-child(2) {
    color: ${({ $check }) => ($check === true ? "#107c41" : "#ff2222")};
    font-size: 12px;
  }
`;

const InputWrap = styled.div`
  width: 370px;
  display: flex;
  font-size: 15px;
  flex-direction: column;
  gap: 5px;
  position: relative;
  box-sizing: border-box;
`;

const NicknameComment = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  font-size: 12px;
  color: #8a8a8a;
`;

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 15px 40px;
`;

const AssignSpan = styled.span`
  width: 56px;
  font-size: 12px;
  color: #107c41;
  border-bottom: 1px solid #107c41;
  translate: 0 10px;
  cursor: pointer;
  &:hover {
    font-weight: 700;
  }
`;
const ErrorText = styled.div`
  font-size: 12px;
  color: #ea1e23;
  white-space: pre-line;
  margin-top: 30px;
`;
const InputItem = styled.div`
  display: flex;
  /* gap: 10px; */
  align-items: center;
`;

const CheckButton = styled.div`
  display: flex;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 24px;
  font-size: 12px;
  cursor: pointer;

  border-radius: 6px;
  border: 1px solid #d1d1d1;
  &:hover {
    opacity: 0.8;
  }
`;

const CustomInput = styled.input`
  width: ${({ $assign }) => ($assign ? "270px" : "370px")};
  height: 30px;

  border-radius: 6px;
  border: 1px solid #8a8a8a;
  padding: 0 10px;
  color: ${({ $check }) =>
    $check === true ? "#107c41" : $check === false ? "#ff3333" : "#242424"};

  &::placeholder {
    color: #242424;
  }
  box-sizing: border-box;
`;

const LoginButton = styled.div`
  width: 370px;
  height: 30px;
  color: #fff;
  background-color: #107c41;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  margin-top: 40px;
  align-items: center;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
